module.exports = __webpack_public_path__ + "static/media/scoodle_icon_colour.b0ff58b4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/scoodle_icon_colour.svg
// module id = 78
// module chunks = 0